module.exports = __webpack_public_path__ + "8e0cd960002f68e1ec22fc845a2442ce.pdf";